import React from 'react';
import App from './App';
import { UserProvider } from './context/UserContext';

const Root = () => {
  return (
    <UserProvider>
      <App />
    </UserProvider>
  );
};

export default Root;